"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDriverInfo = addDriverInfo;
exports.default = void 0;
exports.deleteDriverInfo = deleteDriverInfo;
exports.getDriverInfoList = getDriverInfoList;
exports.getDriverSchedule = getDriverSchedule;
exports.queryQywxDepartment = queryQywxDepartment;
exports.queryQywxDeptUsers = queryQywxDeptUsers;
exports.updateDriverInfo = updateDriverInfo;

var _request = _interopRequireDefault(require("@/utils/request"));

function getDriverInfoList(params) {
  return (0, _request.default)({
    url: 'api/driverInfo',
    method: 'get',
    params: params
  });
}

function addDriverInfo(data) {
  return (0, _request.default)({
    url: 'api/driverInfo',
    method: 'post',
    data: data
  });
}

function queryQywxDeptUsers() {
  return (0, _request.default)({
    url: 'api/driverInfo/queryQywxDeptUsers',
    method: 'get'
  });
}

function queryQywxDepartment() {
  return (0, _request.default)({
    url: 'api/driverInfo/queryQywxDepartment',
    method: 'get'
  });
}

function updateDriverInfo(data) {
  return (0, _request.default)({
    url: 'api/driverInfo',
    method: 'put',
    data: data
  });
}

function deleteDriverInfo(id) {
  return (0, _request.default)({
    url: "api/driverInfo/".concat(id),
    method: 'delete'
  });
}

function getDriverSchedule(params) {
  return (0, _request.default)({
    url: 'api/driverInfo/schedule',
    method: 'get',
    params: params
  });
}

var _default = {
  getDriverInfoList: getDriverInfoList,
  addDriverInfo: addDriverInfo,
  updateDriverInfo: updateDriverInfo,
  deleteDriverInfo: deleteDriverInfo,
  queryQywxDeptUsers: queryQywxDeptUsers,
  queryQywxDepartment: queryQywxDepartment,
  getDriverSchedule: getDriverSchedule
};
exports.default = _default;